module.exports = __webpack_public_path__ + "static/media/Affiche Rock Cafe.788f0620.jpeg";